import { SET_INTERCOM } from "./constants";
import chatHelper from "@/service/helpers-chat";
export default {
	_initIntercomBackup: async ({ commit, rootState }) => {
		
		const reservation =
			rootState.reservation.reservationModel.id != -1
				? rootState.reservation.reservationModel
				: rootState.service.checkinModel.reservation;
		
		let name = reservation.client.fullName;
		let email = reservation.client.email;
		let resId = reservation.id;
		let userId = reservation.client.id;
    let phone  = reservation.client.phone??''
		chatHelper.identify({
			userId: userId,
			reservation_id: resId,
      phoneNumber:phone,
			name,
			email,
			created_at: new Date().getTime() / 1000,
      customFields: {
        'sc_reservation_id': resId
      }
		});
		commit(SET_INTERCOM, true);
	},
	_initIntercom: async () => {
		chatHelper.start();
	},
	_hideIntercomLauncher: async () => {
		chatHelper.shutdown();
	},
	_showIntercomLauncher: async () => {
		chatHelper.start();
		chatHelper.openChat();
	},
	_triggerEventMkt :async(_,eventName)=>{
		if (typeof window.hj === "function") {
			window.hj("event", eventName);
			console.log("event fired:",eventName);
		}
	}
};
